import { render, staticRenderFns } from "./PdpProductSummary.vue?vue&type=template&id=cfe543d8&"
import script from "./PdpProductSummary.vue?vue&type=script&lang=js&"
export * from "./PdpProductSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports